module.exports = __webpack_public_path__ + "img/finance_blue.095f9b03.svg";